module.exports = __webpack_public_path__ + "public/audio/sounds-160.ogg";